import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {Customer} from 'src/app/customers/shared/model/customer.model';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class CustomerResolver implements Resolve<Observable<Customer>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<Customer> {
    const customerId = route.queryParams['c'];
    return this.facadeService.getCustomerById(+customerId).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
